/* Google Consent Mode v2 helpers.
 * Default consent is set to 'denied' in public/index.html BEFORE GTM loads.
 * This module updates consent after the user chooses, and exposes the choice
 * to the rest of the app (server-side conversions only fire when granted).
 */
const KEY = "otp_consent_v2";

export function getConsent() {
  try {
    return localStorage.getItem(KEY); // "granted" | "denied" | null
  } catch (e) {
    return null;
  }
}

export function hasMarketingConsent() {
  return getConsent() === "granted";
}

function applyGtag(granted) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const state = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_storage: state,
    analytics_storage: state,
    ad_user_data: state,
    ad_personalization: state,
  });
}

export function setConsent(granted) {
  try {
    localStorage.setItem(KEY, granted ? "granted" : "denied");
  } catch (e) {
    /* no-op */
  }
  applyGtag(granted);
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: granted ? "consent_granted" : "consent_denied" });
  }
}
